import { useQuery } from "@tanstack/react-query";
import { withPrefix } from "gatsby";

const baseUrl = process.env.GATSBY_BABEL_BASE_URL_SITE;

export const useProduct = (productEnabled, sku) => {
  const pathPrefix = withPrefix("/");
  const market = `${pathPrefix.slice(1, -1).split("_")?.[0]}/${pathPrefix
    .slice(1, -1)
    .split("_")?.[1]
    ?.toLowerCase()}`;

  return useQuery({
    queryKey: ["product", sku],
    enabled: !!sku && productEnabled,
    queryFn: async () => {
      try {
        const response = await fetch(`${baseUrl}/product/${sku}/www/${market}`);
        const data = await response.json();
        return data;
      } catch (err) {
        console.log("Load product error: ", err);
      }
    },
  });
};
